module.exports = __webpack_public_path__ + "5b7af802f4f84b9f8c8d3bf0567ce667.MP3";